<div class="logout-modal-container">
  <div class="logout-modal-content">
    <div class="logout-modal-title">{{ "USER_NAVBAR.0" | translate }}</div>
    <div class="logout-modal-description">
      {{ "USER_NAVBAR.1" | translate }}
    </div>
  </div>
  <div class="modal-footer-container">
    <div class="button-white button-padding-10 button-text" (click)="close()">
      {{ "USER_NAVBAR.2" | translate }}
    </div>
    <div class="button-green button-padding-10 button-text" (click)="logout()">
      {{ "USER_NAVBAR.3" | translate }}
    </div>
  </div>
</div>
